var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFemaleGender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_6_",
    "data-name": "user (6)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 46.5,
    cy: 46.5,
    r: 46.5,
    transform: "translate(0 0)",
    fill: "#eceff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M132.738,126.325a17.329,17.329,0,0,0-7.19-3.321l-12.8-2.568a2.9,2.9,0,0,1-2.311-2.86V114.25c12.752-1.22,14.59-3.823,14.59-6.478,0-7.85-5.218-26.076-6.075-29.041-.111-4.581-.945-7.155-3.041-9.414-1.482-1.6-3.665-1.978-5.422-2.276a9.432,9.432,0,0,1-1.99-.473A20.662,20.662,0,0,0,98.643,64c-7.686.315-17.135,5.206-20.368,14.147-.233.835-5.772,20.573-5.772,29.624,0,3.776,4.266,5.766,14.59,6.677v3.128a2.9,2.9,0,0,1-2.323,2.86L71.96,123a17.367,17.367,0,0,0-7.167,3.315,2.925,2.925,0,0,0-.344,4.249,46.464,46.464,0,0,0,68.633,0,2.916,2.916,0,0,0-.344-4.243Z",
    transform: "translate(-52.455 -52.707)",
    fill: "#2196f3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleGender);
export default __webpack_public_path__ + "static/media/female-gender.d2ebfa9912cd6c80e2249beb7f3cfa27.svg";
export { ForwardRef as ReactComponent };